import styled from "styled-components/macro";
import React, { useEffect, useState } from "react";
import {
  MdArrowBackIos,
  MdArrowForwardIos,
  MdCancel,
  MdDelete,
  MdImage,
  MdMenu,
  MdNotInterested,
} from "react-icons/md";

import "../styles/Products.css";
import "../styles/Sidebar.css";
import { useLocation, useNavigate } from "react-router";
import { isEmpty } from "../functions/isEmpty";
import Camera from "../components/Camera";

export default function Dokumente({
  isMobile,
  products,
  apiURL,
  reloadProducts,
  setReloadProducts,
  page,
  variationProducts,
  setVariationProducts,
  searchString,
  setSearchString,
}) {
  const location = useLocation();
  let navigate = useNavigate();
  const [activeID, setActiveID] = useState("");
  const [recordStreams, setRecordStreams] = useState([]);
  const [activeCamera, setActiveCamera] = useState(false);

  const [title, setTitle] = useState("");
  const [bilder, setBilder] = useState([]);
  const [dokumentenart, setDokumentenart] = useState("");
  const [note, setNote] = useState("");
  const [dateDay, setDateDay] = useState("");
  const [dateMonth, setDateMonth] = useState("");
  const [dateYear, setDateYear] = useState("");
  const [betreff, setBetreff] = useState("");

  const [isLoading, setIsLoading] = useState(false);

  const [mediaImageURL, setMediaImageURL] = useState("");
  const [imageUploads, setImageUploads] = useState([]);

  /*
TODO: 
1. csv upload skript backend
2. felder rechts: zuordnen zu einem dokument: select, welches ein scope hat nach erstellungsdatum


  */

  const setActiveElement = (element) => {
    setActiveID(element.id);
    setTitle(element.titel);
    setDokumentenart(element.dokumentenart);
    setNote(element.note);
    setDateDay(element.dateDay);
    setDateMonth(element.dateMonth);
    setDateYear(element.dateYear);
    setBetreff(element.betreff);

    let newArray = [];
    JSON.parse(element.bilder).map((pic) => newArray.push(pic.url));
    setBilder(newArray);
    setMediaImageURL(JSON.parse(element.bilder)[0].url);
    setImageUploads([]);
  };

  useEffect(() => {
    if (!isEmpty(products) && !isEmpty(activeID)) {
      for (let i = 0; i < products.length; i++) {
        if (products[i].id == activeID) {
          let newArray = [];
          JSON.parse(products[i].bilder).map((pic) => newArray.push(pic.url));
          setBilder(newArray);
        }
      }
    }
  }, [products]);

  const handleUpload = async (imgURL) => {
    if (isLoading) {
      return;
    }
    setIsLoading(true);

    let pics = [];
    bilder.map((img) => pics.push({ url: img }));
    if (!isEmpty(imgURL)) {
      pics.push({ url: imgURL });
    }
    let helpArr = [];
    if (pics.length > 1) {
      pics.map((img) => {
        if (
          img.url !=
          "https://www.cloud.leefes.com/api/images/placeholder/profilbild.svg"
        ) {
          helpArr.push(img);
        }
      });
    } else {
      helpArr = pics;
    }

    const resa = await fetch(
      `${apiURL}/api/dokumente/index.php?id=` + activeID,
      {
        method: "POST",
        headers: {
          //   Authorization: `Bearer ${authToken?.JWT}`,
          "Content-type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
        body: JSON.stringify({
          bilder: JSON.stringify(helpArr),
          titel: title,
          dokumentenart: dokumentenart,
          dateDay: dateDay,
          dateMonth: dateMonth,
          dateYear: dateYear,
          note: note,
          betreff: betreff,
        }),
      }
    );

    await resa.text().then((value) => uploadEnds(value));
  };

  const addNewProduct = async () => {
    if (isLoading) {
      return;
    }
    setIsLoading(true);

    const resa = await fetch(`${apiURL}/api/dokumente/index.php`, {
      method: "PUT",
      headers: {
        //   Authorization: `Bearer ${authToken?.JWT}`,
        "Content-type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
      body: JSON.stringify({
        titel: "New Document",
        dokumentenart: "Rechnungen / Rechnungsbescheide",
        dateDay: getTodayDay(),
        dateMonth: getCurrentMonthInGerman(),
        dateYear: getCurrentYear(),
        note: note,
      }),
    });

    await resa.text().then((value) => uploadEnds(value));
  };

  const duplicateProduct = async () => {
    if (isLoading) {
      return;
    }
    setIsLoading(true);

    let pics = [];
    bilder.map((img) => pics.push({ url: img }));

    const resa = await fetch(`${apiURL}/api/dokumente/index.php`, {
      method: "PUT",
      headers: {
        //   Authorization: `Bearer ${authToken?.JWT}`,
        "Content-type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
      body: JSON.stringify({
        bilder: JSON.stringify(pics),
        titel: "Kopie von " + title,
        dokumentenart: dokumentenart,
        dateDay: dateDay,
        dateMonth: dateMonth,
        dateYear: dateYear,
        note: note,
        betreff: betreff,
      }),
    });

    await resa.text().then((value) => uploadEnds(value));
  };

  const uploadEnds = (value) => {
    setIsLoading(false);
    setReloadProducts(!reloadProducts);
    closeCamera();
    if (isMobile) {
      setActiveID("");
    }

    if (value != "") {
      setImageUploads([]);
    }
  };

  const closeCamera = () => {
    recordStreams.forEach((stream) => {
      stream.getTracks().forEach((track) => track.stop());
    });
    setRecordStreams([]);
    setActiveCamera(false);
  };

  useEffect(() => {
    var productList = document.getElementById("productList");
    var productDetail = document.getElementById("productDetail");

    if (productList != null && productDetail != null) {
      if (isMobile && activeID == "") {
        productDetail.classList.add("d-none");
        productList.classList.remove("d-none");
      } else if (isMobile) {
        productDetail.classList.remove("d-none");
        productList.classList.add("d-none");
      } else {
        productList.classList.remove("d-none");
        productDetail.classList.remove("d-none");
      }
    }
  }, [isMobile, activeID]);

  const dokumentenarten = [
    "Rechnungen / Rechnungsbescheide",
    "Vertrag / Rechtliches / Urkunden / Bescheide",
    "Zugangsdaten / Anschreiben",
  ];

  const tage = [
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "10",
    "11",
    "12",
    "13",
    "14",
    "15",
    "16",
    "17",
    "18",
    "19",
    "20",
    "21",
    "22",
    "23",
    "24",
    "25",
    "26",
    "27",
    "28",
    "29",
    "30",
    "31",
  ];

  const monate = [
    "Januar",
    "Februar",
    "März",
    "April",
    "Mai",
    "Juni",
    "Juli",
    "August",
    "September",
    "Oktober",
    "November",
    "Dezember",
  ];

  const jahre = [
    "2023",
    "2024",
    "2025",
    "2026",
    "2027",
    "2028",
    "2029",
    "2030",
  ];

  function getTodayDay() {
    let today = new Date();
    let day = today.getDate();
    return day.toString();
  }

  function getCurrentMonthInGerman() {
    const monthsInGerman = [
      "Januar",
      "Februar",
      "März",
      "April",
      "Mai",
      "Juni",
      "Juli",
      "August",
      "September",
      "Oktober",
      "November",
      "Dezember",
    ];

    let today = new Date();
    let monthIndex = today.getMonth(); // getMonth() returns month from 0-11
    return monthsInGerman[monthIndex];
  }

  function getCurrentYear() {
    let today = new Date();
    let year = today.getFullYear();
    return year.toString();
  }

  const insertLocalImage = (e) => {
    if (e.target.files.length !== 0) {
      let file = e.target.files[0];
      let filetype = "image";
      let newArray = [];
      imageUploads.map((imgObj) => newArray.push(imgObj));
      newArray.push({
        localURL: URL.createObjectURL(file),
        files: file,
        filetype: filetype,
      });
      setImageUploads(newArray);
      setMediaImageURL(URL.createObjectURL(file));
    } else {
      return;
    }

    return;
  };

  const handleUploadForImage = async () => {
    setIsLoading(true);

    const files = document.getElementById("imgInp").files;
    const formData = new FormData();
    if (!isEmpty(imageUploads)) {
      setMediaImageURL(imageUploads[0].localURL);
    }

    for (let i = 0; i < files.length; i++) {
      let file = files[i];

      formData.append("files[]", file);
    }

    if (files.length != 0 && !isEmpty(imageUploads)) {
      const res = await fetch(`${apiURL}/api/images/process.php`, {
        headers: {
          //  Authorization: `Bearer ${authToken?.JWT}`,
        },
        method: "POST",
        body: formData,
      });

      await res.text().then((value) => handleUpload(value));
    } else {
      handleUpload();
    }
  };

  const removeImage = () => {
    let newArray = [];
    for (let i = 0; i < bilder.length; i++) {
      if (bilder[i] != mediaImageURL) {
        newArray.push(bilder[i]);
      }
    }
    setBilder(newArray);
  };

  const moveImage = (direction) => {
    let searchString = mediaImageURL;
    const array = [];
    bilder.map((img) => array.push(img));
    const index = array.indexOf(searchString);
    // Check if the searchString is present in the array
    if (index === -1) {
      console.error("String not found in array");
      return array;
    }

    // Check if the searchString is not at the start or end of the array
    if (
      (index > 0 && direction === -1) ||
      (index < array.length - 1 && direction === 1)
    ) {
      // Swap the elements
      const temp = array[index];
      array[index] = array[index + direction];
      array[index + direction] = temp;

      setBilder(array);
    } else {
      console.error("Cannot move element beyond array bounds");
      return array;
    }
  };

  const resetImageUpload = () => {
    setImageUploads([]);
    setMediaImageURL(bilder[0]);
  };

  const handleClickOpenCamera = () => {
    navigator.mediaDevices
      .getUserMedia({ video: true, audio: true })
      //   .getUserMedia({ video: true })
      .then((stream) => {
        setActiveCamera(true);
        let helpArr = recordStreams;
        helpArr.push(stream);
        setRecordStreams(helpArr);
      })
      .catch((err) => {
        console.error("Error accessing the camera: ", err);
        setActiveCamera(false);
        alert(
          "Error accessing the camera. Please ensure your browser settings allow camera access and the website is served over HTTPS."
        );
      });
  };

  const onVideoRecorded = (imgObject) => {
    let helpArr = [...imageUploads];
    helpArr.push(imgObject);
    setImageUploads(helpArr);
  };

  const uploadPhotos = async () => {
    setIsLoading(true);

    const files = [...imageUploads];
    const formData = new FormData();

    for (let i = 0; i < files.length; i++) {
      let file = files[i].files;

      formData.append("files[]", file);
    }

    if (files.length != 0 && !isEmpty(imageUploads)) {
      const res = await fetch(`${apiURL}/api/images/process.php`, {
        headers: {
          //  Authorization: `Bearer ${authToken?.JWT}`,
        },
        method: "POST",
        body: formData,
      });

      await res.text().then((value) => uploadPhotosTaken(value));
    } else {
      alert("empty");
    }
  };

  function splitByHttps(inputString) {
    // Split the string by "https"
    const parts = inputString.split("https");

    // Initialize an array to store the resulting strings
    const result = [];

    // Iterate through the split parts
    for (let i = 0; i < parts.length; i++) {
      if (i === 0) {
        // The first part is before the first "https"
        if (parts[i] !== "") {
          result.push(parts[i]);
        }
      } else {
        // Reattach "https" to the subsequent parts
        result.push({ url: "https" + parts[i] });
      }
    }

    return result;
  }

  const uploadPhotosTaken = async (imgURLs) => {
    setIsLoading(true);

    let pics = splitByHttps(imgURLs);

    const resa = await fetch(
      `${apiURL}/api/dokumente/index.php?id=` + activeID,
      {
        method: "PUT",
        headers: {
          //   Authorization: `Bearer ${authToken?.JWT}`,
          "Content-type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
        body: JSON.stringify({
          bilder: JSON.stringify(pics),
          titel: "Neues Dokument",
        }),
      }
    );

    await resa.text().then((value) => uploadEnds(value));
  };

  return (
    <div className="page-divider">
      <div className="sidebar">
        <div className="sidebar_top">
          {!isMobile && (
            <div className="" style={{ paddingLeft: "14px" }}>
              Buchhaltung
            </div>
          )}

          {!isMobile ? (
            <>
              {activeCamera ? (
                <div className="sidebar_top">
                  <div
                    className="sidebar_top_navpoint"
                    onClick={() => closeCamera()}>
                    close Camera
                  </div>
                  <div
                    className="sidebar_top_navpoint"
                    onClick={() => uploadPhotos()}>
                    Upload
                  </div>
                </div>
              ) : (
                <>
                  {location.pathname.substring(0, 6) == "/" ? (
                    <div className="sidebar_top_navpoint_active">Dokumente</div>
                  ) : (
                    <div
                      className="sidebar_top_navpoint"
                      onClick={() => navigate("/")}>
                      Dokumente
                    </div>
                  )}
                  {location.pathname.substring(0, 10) == "/ereignisse" ? (
                    <div className="sidebar_top_navpoint_active">
                      Ereignisse
                    </div>
                  ) : (
                    <div
                      className="sidebar_top_navpoint"
                      onClick={() => navigate("/ereignisse")}>
                      Ereignisse
                    </div>
                  )}
                  {location.pathname.substring(0, 12) == "/letsfluence" ? (
                    <div className="sidebar_top_navpoint_active">
                      Kto Letsfluence
                    </div>
                  ) : (
                    <div
                      className="sidebar_top_navpoint"
                      onClick={() => navigate("/letsfluence")}>
                      Kto Letsfluence
                    </div>
                  )}
                  {location.pathname.substring(0, 6) == "/masih" ? (
                    <div className="sidebar_top_navpoint_active">
                      Kto Masih Privat
                    </div>
                  ) : (
                    <div
                      className="sidebar_top_navpoint"
                      onClick={() => navigate("/masih")}>
                      Kto Masih Privat
                    </div>
                  )}
                </>
              )}
            </>
          ) : (
            <>
              {activeID == "" && (
                <div className="topnav">
                  {activeCamera ? (
                    <div className="sidebar_top">
                      <div
                        className="sidebar_top_navpoint"
                        onClick={() => setActiveCamera(false)}>
                        close Camera
                      </div>
                      {!isLoading ? (
                        <div
                          className="sidebar_top_navpoint"
                          onClick={() => uploadPhotos()}>
                          Upload
                        </div>
                      ) : (
                        <div className="sidebar_top_navpoint">...Lädt</div>
                      )}
                    </div>
                  ) : (
                    <div className="sidebar_top">
                      {location.pathname.substring(0, 6) == "/" ? (
                        <div className="sidebar_top_navpoint_active">
                          Letsfluence
                        </div>
                      ) : (
                        <div
                          className="sidebar_top_navpoint"
                          onClick={() => navigate("/")}>
                          Letsfluence
                        </div>
                      )}
                      {location.pathname.substring(0, 7) == "/grillchef" ? (
                        <div className="sidebar_top_navpoint_active">
                          {" "}
                          Grillchef
                        </div>
                      ) : (
                        <div
                          className="sidebar_top_navpoint"
                          onClick={() => navigate("/grillchef")}>
                          Grillchef
                        </div>
                      )}
                    </div>
                  )}
                </div>
              )}
            </>
          )}
        </div>
        <div className="sidebar_bottom"></div>
      </div>
      <div className="products">
        {activeCamera && (
          <Camera
            onPhotoTaken={onVideoRecorded}
            setRecordStreams={setRecordStreams}
            recordStreams={recordStreams}
            isUploading={isLoading}
            imageUploads={imageUploads}
          />
        )}

        <div className="products_left" id="productList">
          <div className="products_list">
            <div className="products_filter">
              <input
                type="text"
                placeholder="Titel filtern"
                className="product_filter_search"
                value={searchString}
                onChange={(e) => setSearchString(e.target.value)}
              />
              <select className="product_filter_select">
                <option value="">Ab</option>
              </select>
              <select className="product_filter_select">
                <option value="">Bis</option>
              </select>
            </div>
            <div className="products_addNew">
              <div
                className="products_addNew_button"
                onClick={() => handleClickOpenCamera()}>
                Open Camera
              </div>
              <div
                className="products_addNew_button"
                onClick={() => duplicateProduct()}>
                Duplicate
              </div>
              <div
                className="products_addNew_button"
                onClick={() => addNewProduct()}>
                + Add New Document
              </div>
            </div>

            {products.map((product) => (
              <>
                {product.id == activeID ? (
                  <>
                    <div className="products_list_element_active">
                      <div className="products_list_element_col">
                        {product.dateDay + "." + product.dateMonth}
                      </div>

                      <div className="products_list_element_col">
                        {product.titel + "   | "}
                      </div>
                      <div className="products_list_element_col">
                        {product.betreff + "   | "}
                      </div>
                      <div className="products_list_element_col">
                        {product.dokumentenart ==
                          "Rechnungen / Rechnungsbescheide" && "RE"}
                        {product.dokumentenart ==
                          "Vertrag / Rechtliches / Urkunden / Bescheide" &&
                          "Vertrag"}
                        {product.dokumentenart ==
                          "Zugangsdaten / Anschreiben" && "Notice"}
                      </div>
                      <div className="products_list_element_col">
                        {JSON.parse(product.bilder)[0].url ==
                        "https://www.cloud.leefes.com/api/images/placeholder/profilbild.svg" ? (
                          <NoDocIcon />
                        ) : (
                          <DocIcon />
                        )}
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    <div
                      className="products_list_element"
                      onClick={() => setActiveElement(product)}>
                      <div className="products_list_element_col">
                        {product.dateDay + "." + product.dateMonth}
                      </div>

                      <div className="products_list_element_col">
                        {product.titel + "   | "}
                      </div>
                      <div className="products_list_element_col">
                        {product.betreff + "   | "}
                      </div>
                      <div className="products_list_element_col">
                        {product.dokumentenart ==
                          "Rechnungen / Rechnungsbescheide" && "RE"}
                        {product.dokumentenart ==
                          "Vertrag / Rechtliches / Urkunden / Bescheide" &&
                          "Vertrag"}
                        {product.dokumentenart ==
                          "Zugangsdaten / Anschreiben" && "Notice"}
                      </div>
                      <div className="products_list_element_col">
                        {JSON.parse(product.bilder)[0].url ==
                        "https://www.cloud.leefes.com/api/images/placeholder/profilbild.svg" ? (
                          <NoDocIcon />
                        ) : (
                          <DocIcon />
                        )}
                      </div>
                    </div>
                  </>
                )}
              </>
            ))}
          </div>
        </div>
        <div className="products_right" id="productDetail">
          {activeID != "" && (
            <>
              {isMobile ? (
                <div className="topnav">
                  <div className="" onClick={() => setActiveID("")}>
                    <LeftIcon /> Zurück
                  </div>
                  {isLoading ? (
                    <div className="savebtn_loading">...Lädt</div>
                  ) : (
                    <div
                      className="savebtn"
                      onClick={() => handleUploadForImage()}>
                      Speichern
                    </div>
                  )}
                </div>
              ) : (
                <div className="topnav">
                  {isLoading ? (
                    <div className="savebtn_loading">...Lädt</div>
                  ) : (
                    <div
                      className="savebtn"
                      onClick={() => handleUploadForImage()}>
                      Speichern
                    </div>
                  )}
                </div>
              )}

              {!isEmpty(imageUploads) ? (
                <div className="">
                  <img
                    className="createService_inputBtn_img"
                    style={{ width: "calc(100% - 24px)" }}
                    src={mediaImageURL}
                  />
                </div>
              ) : (
                <>
                  <img
                    className="createService_inputBtn_img"
                    style={{ width: "calc(100% - 24px)" }}
                    src={mediaImageURL}
                  />
                </>
              )}
              <div className="creator_previewimages">
                {isEmpty(imageUploads) && (
                  <label htmlFor={"imgInp"} className="">
                    <div className="createService_inputlabel">
                      <ImageIcon /> + Upload
                    </div>
                  </label>
                )}

                {bilder.map((creatorimg) => (
                  <>
                    <div
                      className="creator_previewimages_imgbox"
                      onClick={() => setMediaImageURL(creatorimg)}>
                      <img
                        src={creatorimg}
                        className={
                          mediaImageURL == creatorimg
                            ? "creator_previewimages_imgbox_img_active"
                            : "creator_previewimages_imgbox_img"
                        }
                      />
                      {mediaImageURL == creatorimg && bilder.length > 1 && (
                        <div className="creator_previewimages_imgbox_nav">
                          <div
                            className="creator_previewimages_imgbox_nav_btn"
                            onClick={() => removeImage()}>
                            <DeleteIcon />
                          </div>
                          <div
                            className="creator_previewimages_imgbox_nav_btn"
                            onClick={() => moveImage(-1)}>
                            <LeftIcon />
                          </div>
                          <div
                            className="creator_previewimages_imgbox_nav_btn"
                            onClick={() => moveImage(1)}>
                            <RightIcon />
                          </div>
                        </div>
                      )}
                    </div>
                  </>
                ))}
                {imageUploads.map((creatorimg) => (
                  <>
                    <div
                      className="creator_previewimages_imgbox"
                      onClick={() => setMediaImageURL(creatorimg.localURL)}>
                      <img
                        className={
                          mediaImageURL == creatorimg.localURL
                            ? "creator_previewimages_imgbox_img_active"
                            : "creator_previewimages_imgbox_img"
                        }
                        src={creatorimg.localURL}
                      />
                      <div className="creator_previewimages_imgbox_nav">
                        <div className="createService_inputBtn_cancelBtn">
                          <CancelIcon onClick={() => resetImageUpload()} />
                        </div>
                      </div>
                    </div>
                  </>
                ))}
              </div>
              <div className="inputrow">
                <input
                  type="file"
                  accept=".jpg, .jpeg, .png"
                  id={"imgInp"}
                  name="files[]"
                  className="createService_inputBtn d-none"
                  onChange={(e) => insertLocalImage(e)}
                />
              </div>

              <div className=""> Sender Name</div>
              <div className="inputrow">
                <input
                  type="text"
                  className="inputrow_input"
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                />
              </div>
              <div className=""> Betreff</div>
              <div className="inputrow">
                <input
                  type="text"
                  className="inputrow_input"
                  value={betreff}
                  onChange={(e) => setBetreff(e.target.value)}
                />
              </div>

              <div className=""> Dokumentenart</div>
              <div className="inputrow">
                <select
                  onChange={(e) => setDokumentenart(e.target.value)}
                  className="inputrow_input">
                  {dokumentenarten.map((art) => (
                    <>
                      {dokumentenart == art && (
                        <option value={art} selected>
                          {art}
                        </option>
                      )}
                      <option value={art}>{art}</option>
                    </>
                  ))}
                </select>
              </div>
              <div className=""> Datum des Dokuments Tag</div>
              <div className="inputrow">
                <select
                  onChange={(e) => setDateDay(e.target.value)}
                  className="inputrow_input">
                  {tage.map((tag) => (
                    <>
                      {dateDay == tag ? (
                        <option value={tag} selected>
                          {tag}
                        </option>
                      ) : (
                        <option value={tag}>{tag}</option>
                      )}
                      +
                    </>
                  ))}
                </select>
              </div>
              <div className=""> Datum des Dokuments Monat</div>
              <div className="inputrow">
                <select
                  onChange={(e) => setDateMonth(e.target.value)}
                  className="inputrow_input">
                  {monate.map((tag) => (
                    <>
                      {dateMonth == tag ? (
                        <option value={tag} selected>
                          {tag}
                        </option>
                      ) : (
                        <option value={tag}>{tag}</option>
                      )}
                      +
                    </>
                  ))}
                </select>
              </div>
              <div className=""> Datum des Dokuments Jahr</div>
              <div className="inputrow">
                <select
                  onChange={(e) => setDateYear(e.target.value)}
                  className="inputrow_input">
                  {jahre.map((tag) => (
                    <>
                      {dateYear == tag ? (
                        <option value={tag} selected>
                          {tag}
                        </option>
                      ) : (
                        <option value={tag}>{tag}</option>
                      )}
                      +
                    </>
                  ))}
                </select>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

const MenuIcon = styled(MdMenu)`
  font-size: 33px;
  color: #575757;
`;

const ArrowBack = styled(MdArrowBackIos)`
  font-size: 22px;
  color: #575757;
  margin-top: -1px;
  margin-left: 10px;
`;

const CancelIcon = styled(MdCancel)`
  font-size: 33px;
  color: #575757;
`;
const DeleteIcon = styled(MdDelete)`
  font-size: 33px;
  color: #575757;
`;

const ImageIcon = styled(MdImage)`
  font-size: 33px;
  color: #575757;
`;

const NoDocIcon = styled(MdNotInterested)`
  font-size: 33px;
  color: #575757;
`;

const DocIcon = styled(MdImage)`
  font-size: 33px;
  color: #575757;
`;

const LeftIcon = styled(MdArrowBackIos)`
  font-size: 22px;
  color: #575757;
  margin-top: -1px;
  margin-left: 10px;
`;

const RightIcon = styled(MdArrowForwardIos)`
  font-size: 22px;
  color: #575757;
  margin-top: -1px;
  margin-left: 10px;
`;
